import { useMemo } from 'react';

import { TABLET } from '@app/constants';
import {
  useNewUserAccessRights,
  useUserPrint,
  useWindowSize,
} from '@app/hooks';
import { useNotification } from '@app/providers/NotificationProvider/NotificationContext';
import { handleCatchError } from '@app/services';
import { useLazyGetYookassaGetCodeUrlQuery } from '@app/services/rtkQuery/SocialIntegrations/api';

export const useIntegrationsPageHeader = () => {
  const { activeBranchId: ActiveBranchId } = useUserPrint();

  const [getYookassaGetCodeUrl] = useLazyGetYookassaGetCodeUrlQuery();

  const { showNotification } = useNotification();

  const { innerWidth } = useWindowSize();
  const {
    userAccessRights: {
      Integrations: { IsCreate },
    },
  } = useNewUserAccessRights();

  const label = useMemo(() => {
    if (innerWidth <= TABLET) {
      return '';
    }
    return 'Добавить интеграцию';
  }, [innerWidth]);

  const navigateToYooKassaAccessRightPage = async () => {
    try {
      const { Url } = await getYookassaGetCodeUrl({ ActiveBranchId }).unwrap();
      window.location.href = Url;
    } catch (error) {
      showNotification(handleCatchError(error));
    }
  };

  return { label, IsCreate, navigateToYooKassaAccessRightPage };
};
